
const state = {
  CompanyCode: [
    { code: '4031', name: 'BFE' },
    { code: '4033', name: 'SSPC' },
    { code: '4036', name: 'KABI' }
  ]
}

export default {
  state
}
